import { createSearchParams, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth.store';
import AppError from './AppError';

function AuthGuard({
  shouldBeAuthenticated = true,
  children,
}: {
  shouldBeAuthenticated?: boolean;
  children: JSX.Element;
}) {
  const { isLoggedIn, _hasHydrated, _error } = useAuth();
  const location = useLocation();

  if (!_hasHydrated) {
    return <></>;
  }

  if (_error) {
    throw _error;
  }

  if (shouldBeAuthenticated && !isLoggedIn) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    const searchParams = {
      redirect: location.pathname || '/',
    };
    return <Navigate to={{ pathname: '/login', search: `?${createSearchParams(searchParams)}` }} replace />;
  } else if (!shouldBeAuthenticated && isLoggedIn) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}

export default AuthGuard;
